module.exports = __webpack_public_path__ + "img/5.faca146e.jpg";